import { combineReducers } from "redux";

import { authentication } from "./authentication.reducer"
import { alert } from "./alert.reducer"
import { licences } from "./licences.reducer"
import { licence } from "./licence.reducer"
import { orders } from "./orders.reducer"
import { order } from "./order.reducer"
import { systems } from "./systems.reducer"
import { system } from "./system.reducer"

export default () => combineReducers({
    authentication,
    alert,
    licences,
    licence,
    orders,
    order,
    systems,
    system
});